import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/pointcloud';

export class PointCloudService implements types.Handlers {
  private serviceEndpoint = '/pointclouds';
  constructor(private axios: AxiosInstance) {}
  async createPointCloud({
    body,
  }: types.CreatePointCloudParameters): Promise<types.CreatePointCloudResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/create`, {
        ...body,
      })
    ).data;
  }
  async fetchById(params: types.FetchByIdParameters): Promise<common.FetchPointCloudResponse> {
    return (await this.axios.get(`/pointclouds/${params.path.id}`)).data;
  }
  async delete({ path }: types.DeleteParameters): Promise<types.DeletePointCloudResponse> {
    return (await this.axios.delete(`${this.serviceEndpoint}/${path.id}`)).data;
  }
  fetchCesiumTileSet(
    params: types.FetchCesiumTileSetParameters,
  ): Promise<types.FetchTileSetResponse> {
    throw new Error('Method not implemented.');
  }
  fetchCesiumPnts(params: types.FetchCesiumPntsParameters): Promise<common.DownloadURLResponse> {
    throw new Error('Method not implemented.');
  }
  async fetchSignRequestParameters({
    path,
    query,
  }: types.FetchSignRequestParametersParameters): Promise<common.SignedRequestResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${path.pointCloudId}/signed-request`, {
        params: query,
      })
    ).data;
  }
}
